import React, { useState, useEffect, useCallback } from 'react';
import Loader from "../../../iu/loader/loader.js";
import FormularioComentario from '../Reportes/comentario/FormularioComentario.js';
import { getReportesByUserID } from '../../../services/reporteService';
import DetallesDenuncia from '../../../iu/detallesDenuncia/detallesReporte';
import './MisReportes.css';

import { getComentarioByDenunciaID } from '../../../services/comentarioDenunciaService.js';

import { useUser } from '../../../userContext.js';

const MisReportes = () => {
    const [mostrarFormularioComentario, setMostrarFormularioComentario] = useState(false);
    const [idDenuncia, setIdDenuncia] = useState(0);
    const [loading, setLoading] = useState(true);

    const { id, token } = useUser();
    const userID = id;
    const [datosDenuncia, setDatosDenuncia] = useState({});

    const [denuncias, setDenuncias] = useState([]);
    const [mostrarDetalles, setMostrarDetalles] = useState(false);

    const fetchDenuncias = useCallback(async () => {
        try {
            setLoading(true);
            let data = await getReportesByUserID({ token, userID });
            //obtener los comentarios para cada una de las denuncias y agregarlos a la denuncia
            for (let i = 0; i < data.length; i++) {
                const comentarios = await getComentarioByDenunciaID({ token, denunciaID: data[i].id });
                data[i].comentarios = comentarios;
            }
            //ordenar para que primero aparezcan capturadas, en revision y atendidas
            data.sort((a, b) => {
                if (a.estatus === 'Capturado') {
                    return -1;
                }
                if (a.estatus === 'En revisión' && b.estatus === 'Atendida') {
                    return -1;
                }
                return 1;
            });
            setDenuncias(data);
        } catch (error) {
            console.error('Error al obtener las denuncias:', error.message);
        } finally {
            setLoading(false);
        }
    }, [token, userID]);

    useEffect(() => {
        fetchDenuncias();
        const interval = setInterval(() => {
            fetchDenuncias();
        }, 30000);

        return () => clearInterval(interval); // Limpiar el intervalo al desmontar el componente
    }, [fetchDenuncias]);

    const getEstatusClass = (estatus) => {
        switch (estatus) {
            case 'Capturado':
                return 'capturado-title';
            case 'En revisión':
                return 'revision-title';
            case 'Atendida':
                return 'atendida-title';
            default:
                return '';
        }
    };

    const handleVerDetalles = (denunciaID) => {
        return () => {
            const denuncia = denuncias.find(denuncia => denuncia.id === denunciaID);
            setDatosDenuncia(denuncia);
            setMostrarDetalles(true);
        };
    }
    const handleCerrarDetalles = () => {
        setMostrarDetalles(false);
    }
    const handleCerrarFormularioComentario = () => {
        setMostrarFormularioComentario(false);
        fetchDenuncias();
    }

    const handleAgregarComentario = (denunciaID) => {
        setIdDenuncia(denunciaID);
        setMostrarFormularioComentario(true);
    };


    const formatearFecha = (fecha) => {
        const fechaHora = fecha.split('T');
        const fechaArray = fechaHora[0].split('-');
        let horaArray = fechaHora[1].split(':');
        //QUITARLE 6 HORAS A LA HORA
        horaArray[0] = horaArray[0] - 6;
        return `${fechaArray[2]}/${fechaArray[1]}/${fechaArray[0]} ${horaArray[0]}:${horaArray[1]}`;
    };

    return (
        <div className='main'>
            <div className='titulo-componentes mis-reportes'>Mis reportes</div>
            {loading ? (
                <Loader />
            ) : (
                <div className='contenido-componentes'>
                    {denuncias.length === 0 ? (
                        <div className='not-found'>Ups... parece que aun no has creado un reporte</div>
                    ) : (
                        <div className='denuncias-list'>
                            {denuncias.map(denuncia => (
                                <div key={denuncia.id} className="denuncia-card">
                                    <div className={`denuncia-status ${getEstatusClass(denuncia.estatus)}`}>{denuncia.estatus}</div>
                                    <div className='denuncia-item'>
                                        <div className='contenedor-fecha-estatus'>
                                            <div className='denuncia-fecha'>{formatearFecha(denuncia.createdAt)}</div>
                                            <div className='denuncia-noficio'>N.Folio {denuncia.id}</div>
                                            <div className='denuncia-tipo'>{denuncia.tipo}</div>
                                        </div>
                                        <div className='denuncia-info-contenedor-horizontal'>
                                            <div className='denuncia-info-vertical-denuncia'>
                                                <div className='denuncia-titulo'>{denuncia.titulo}</div>
                                                <img
                                                    src={`${process.env.REACT_APP_URL_API2}/api/uploads/${denuncia.imagenes.split(',')[0]}`}
                                                    alt='imagen de la denuncia'
                                                    className='denuncia-info-foto'
                                                />
                                            </div>
                                            <div className='denuncia-info-vertical-comentario'>
                                                {denuncia.comentarios && denuncia.comentarios.length > 0 ? (
                                                    <>
                                                        {denuncia.comentarios.map((comentario, index) => (
                                                            <div
                                                                key={index}
                                                                className={`denuncia-comentario ${comentario.enviadoPorUsuario ? 'mensaje-usuario' : ''}`}
                                                            >
                                                                <div className='comentario-texto'>
                                                                    {comentario.enviadoPorUsuario && "Usuario: "}
                                                                    {comentario.enviadoPorConvenio && "Convenio: "}
                                                                    {comentario.enviadoPorPolicia && "Policía: "}
                                                                    {comentario.comentario}
                                                                </div>
                                                                {comentario.imagenes === 'sin imagenes' ? (
                                                                    <>
                                                                        {/*<div className='comentario-foto'>No hay fotos</div>*/}
                                                                    </>
                                                                ) : (
                                                                    <img
                                                                        src={`${process.env.REACT_APP_URL_API2}/api/uploads2/${comentario.imagenes.split(',')[0]}`}
                                                                        alt='imagen del comentario'
                                                                        className='comentario-foto'
                                                                    />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div className='denuncia-comentario'>
                                                        <div className='comentario-texto'>No hay comentarios</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='denuncia-info-acciones'>
                                            <button className='boton-secundario' onClick={() => { handleAgregarComentario(denuncia.id) }}>Agregar comentario</button>
                                            <button className='boton-primario' onClick={handleVerDetalles(denuncia.id)}>Ver detalles</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
            {mostrarDetalles && <DetallesDenuncia datosDenuncia={datosDenuncia} onClose={handleCerrarDetalles} />}
            {mostrarFormularioComentario && <FormularioComentario idDenuncia={idDenuncia} cerrar={handleCerrarFormularioComentario} EnviadoPorUsuario={true} />}
        </div>
    );
};

export default MisReportes;
